import { render, staticRenderFns } from "./examConfigBase.vue?vue&type=template&id=b6d613c8&scoped=true&"
import script from "./examConfigBase.vue?vue&type=script&lang=js&"
export * from "./examConfigBase.vue?vue&type=script&lang=js&"
import style0 from "./examConfigBase.vue?vue&type=style&index=0&id=b6d613c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d613c8",
  null
  
)

export default component.exports